const constants = require("../constants");

const {
  PUBLIC_URL,
  NODE_ENV,
  REACT_APP_BASE_URL,
  REACT_APP_OIDC_ISSUER,
  REACT_APP_OIDC_CLIENT_ID,
  REACT_APP_ORG,
  REACT_APP_APP_SIGNAL_API_KEY,
} = process.env;

module.exports = {
  PUBLIC_URL,
  NODE_ENV,
  BASE_URL: `${REACT_APP_BASE_URL}`,
  OIDC_ISSUER: REACT_APP_OIDC_ISSUER,
  OIDC_CLIENT_ID: REACT_APP_OIDC_CLIENT_ID,
  ORG_NAME: REACT_APP_ORG,
  VENUE_ID: constants.VENUE_UUID,
  APP_SIGNAL_API_KEY: REACT_APP_APP_SIGNAL_API_KEY,
};
